module.exports = __webpack_public_path__ + "static/media/coach_monochromatic.724edd37.png";